export enum LoginMethod {
  Simulation = 0,
  SSO = 1,
}

export enum TokenTypes {
  AccessToken = "accessToken",
  RefreshToken = "refreshToken",
}

// Helper function to get environment variables with fallback
const getEnvVar = (key: string, fallback: string = ""): string => {
  return import.meta.env[key] ?? fallback;
};

// Helper function to get required environment variables (throws if missing)
const getRequiredEnvVar = (key: string): string => {
  const value = import.meta.env[key];
  if (value === undefined || value === null || value === "") {
    console.warn("Warning: Required environment variable is not set");
    return "";
  }
  return value;
};

// For critical environment variables, use getRequiredEnvVar
export const surveyBaseURL: string = getRequiredEnvVar(
  "VITE_SURVEY_SERVICE_BASE_URL",
);
export const userBaseURL: string = getRequiredEnvVar(
  "VITE_USER_SERVICE_BASE_URL",
);
export const mapBaseURL: string = getRequiredEnvVar("VITE_MEDIA_BASE_URL");
export const SSOBaseURL: string = getRequiredEnvVar("VITE_SSO_BASE_URL");
export const SSOSignOutURL: string = getRequiredEnvVar("VITE_SSO_SIGNOUT_URL");

// For optional environment variables, use getEnvVar with sensible defaults
export const mediaBaseURL: string = getEnvVar("VITE_MEDIA_SERVICE_BASE_URL");
export const siqBaseUrl: string = getEnvVar("VITE_SIQ_BASE_URL");
export const BAMmapAPI: string = getEnvVar("VITE_BAM_API");
export const BAMWSO2Token: string = getEnvVar("VITE_WSO2_BAM_TOKEN");
export const BAMWS02API: string = getEnvVar("VITE_WSO2_BAM_API");
export const appRootURL: string = getEnvVar("VITE_APP_ROOT_URL");
export const BAMWSO2ClientID: string = getEnvVar("VITE_WSO2_CLIENT_ID");
export const BAMWSO2SecretID: string = getEnvVar("VITE_WSO2_SECRET_ID");
export const EnvironmentType: string = getEnvVar(
  "VITE_ENVIRONMENT_TYPE",
  "development",
);
export const interactiveSurveyCoverDefaultImg: string = getEnvVar(
  "VITE_INTERACTIVE_SURVEY_DEFAULT_COVER_IMAGE",
);
export const interactiveSurveyOrigins: string = getEnvVar(
  "VITE_INTERACTIVE_SURVEY_ORIGINS",
);
export const defaultSupportEmail: string = getEnvVar(
  "VITE_DEFAULT_SUPPORT_EMAIL",
  "support@example.com",
);
export const bingKey: string = getEnvVar("VITE_BING_KEY");
export const mapboxToken: string = getEnvVar("VITE_MAPBOX_TOKEN");
export const mediaBaseUrl: string = getEnvVar("VITE_MEDIA_BASE_URL");
export const interactiveWebUrl: string = getEnvVar(
  "VITE_INTERACTIVE_WEB_APP_ROOT_URL",
);

// PDF generation error message
export const PDF_GENERATION_ERROR_MESSAGE =
  "We hit a snag generating the PDF link; please try again. If this continues, please reach out via the in-app chat (lower right of your screen).";

// Countries allowed to create new surveys on Home page
export const newSurveyAllowCountries = [
  "fin",
  "finland",
  "dnk",
  "denmark",
  "swe",
  "sweden",
  "nor",
  "norway",
];
